// extracted by mini-css-extract-plugin
export default {"body":"City_body__3GbLm","mapDiv__wrap":"City_mapDiv__wrap__SUBMM","mapDiv":"City_mapDiv__4bDFk","mapDiv2":"City_mapDiv2__H6NCZ"};